import { makeEntityScaffold } from '@classpass/saga-tools';

export const dashFeatureById = makeEntityScaffold(
  'SAGA.API.DASH_FEATURE_BY_ID',
  (client, id) => client.dash.getFeatureFlag(id),
  { defaultKey: 1 }
);
